import { Controller } from 'react-hook-form';

import FormField from 'component/FormField';

export default function InputZipcode({ form }) {
  const { control, formState } = form;
  const { errors } = formState;
  return (
    <Controller
      disabled
      name="zipcode"
      control={control}
      render={({ field }) => (
        <FormField
          disabled
          name="zipcode"
          placeholder="รหัสไปรษณีย์"
          size="large"
          error={!!errors?.zipcode}
          {...field}
        />
      )}
    />
  );
}
